import APIConstant from 'constants/ApiConstant';
import { MYM_WEB } from 'constants/RequestUrlConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import moment from 'moment';
import { getRequest, postRequest } from 'utils/apiUtils';
import { getValidDataFromResponse } from 'utils/utilities';

class MonthlyEducationStore {
	isSubmittingData = false;

	allStateList = [];
	isEducationLoading = false;
	isDeleteEducation = false;
	monthlyEducationData = [];
	rowId = ''

	constructor() {
		makeAutoObservable(this);
	}

	getAllStateList = async () => {
		try {
			const { response } = await getRequest({
				url: APIConstant.GET_ALL_STATE_LIST,
				rbu: MYM_WEB,
			});

			if (response.success && Array.isArray(response.result)) {
				runInAction(() => {
					this.allStateList = [...response.result];
				});
			}
		} catch (error) {
			console.log('Error');
		}
	};

	getMonthlyEducations = ({ toolbox_id, sub_education_type_id, state_id, role_id }) => {
		return new Promise(async (resolve, reject) => {
			try {
				this.setIsEducationLoading(true)
				this.setMonthlyEducationData([])
				const { response } = await getRequest({ url: `${APIConstant.GET_TOOLBOX_EDUCATION}/${toolbox_id}/${sub_education_type_id}/${state_id}/${role_id}` });
				const { result, error } = getValidDataFromResponse({ response, isRequired: false });

				if (!error) {
					this.setIsEducationLoading();
					this.setMonthlyEducationData(result);
					resolve();
				} else {
					this.setIsEducationLoading();
					throw new Error('Something went wrong');
				}

				// console.log('response', result, error);
			} catch (error) { }
		});
	};

	deleteEducation = ({ toolbox_id }) => {
		return new Promise(async (resolve, reject) => {
			try {
				const { response } = await getRequest({ url: `${APIConstant.DELETE_EDUCATION}/${toolbox_id}` });
				const { result, error } = getValidDataFromResponse({ response, isRequired: false });

				if (!error) {
					this.setIsDeleteEducation();
					resolve();
				} else {
					this.setIsDeleteEducation();
					throw new Error('Something went wrong');
				}

				// console.log('response', result, error);
			} catch (error) { }
		});
	};


	submitMonthlyEducationData = data => {
		return new Promise(async (resolve, reject) => {
			try {
				const { education_date, ...rest } = data;

				const new_body = {
					education_date: moment(education_date).format(`MMMM YYYY`),
					...rest,
				};

				this.isSubmittingData = true;

				const { response } = await postRequest({
					url: APIConstant.MONTHLY_EDUCATION_DETAILS,
					rbu: MYM_WEB,
					payload: new_body,
				});

				const { result, error } = getValidDataFromResponse({ response });

				if (!error) {
					runInAction(() => {
						this.isSubmittingData = false;
					});
					resolve();
				} else {
					throw new Error(`Failed to submit`);
				}
			} catch (error) {
				runInAction(() => {
					this.isSubmittingData = false;
				});
			}
		});
	};

	setMonthlyEducationData = (data = []) => {
		runInAction(() => {
			this.monthlyEducationData = data;
		});
	};

	setIsEducationLoading = (value = false) => {
		runInAction(() => {
			this.isEducationLoading = value
		})
	}

	setIsDeleteEducation = (value = false, rowId = '') => {
		return new Promise((resolve, reject) => {
			runInAction(() => {
				this.isDeleteEducation = value;
				this.rowId = rowId;
			});
			resolve();
		});
	}
}

export default MonthlyEducationStore;
